import React from 'react'
import PropTypes from 'prop-types'
import Logo from '../images/logo-tuya-opacity.inline.svg'
import FacebookIcon from '../images/facebook.inline.svg'
import InstagramIcon from '../images/instagram.inline.svg'
import Pattern from '../images/tuya-pattern-big.inline.svg'
import { useTranslation, Trans, Link } from 'gatsby-plugin-react-i18next'

const BlockMenu = ({ name, items, color }) => {
  const textClass = `${color} text-tuya-chi tracking-tightish`
  return (
    <>
      <h6 className="text-tuya-alpha tracking-widest mb-4 uppercase">{name}</h6>
      <ul className="leading-8">
        {items.map((item, idx) => (
          <li key={idx}>
            {item.path.indexOf('https') === 0 ? (
              <a href={item.path} target="_blank" rel="noreferrer" className={textClass} title={item.title}>
                {item.title}
              </a>
            ) : (
              <>
                {item.path !== '' ? (
                  <Link to={`${item.path}`} className={textClass}>
                    <Trans>{item.title}</Trans>
                  </Link>
                ) : (
                  <span className="text-tuya-chi">{item.title}</span>
                )}
              </>
            )}
          </li>
        ))}
      </ul>
    </>
  )
}

const navLocations = [
  { title: 'Mykonos', path: 'https://www.tuya.gr/' },
  { title: 'Bucharest', path: 'https://www.tuya.ro' },
]
const navPlace = [
  { title: 'menu_food', path: '/food/' },
  { title: 'menu_restaurant', path: '/concept/' },
  { title: 'menu_contact', path: '/contact/' },
]
const navLinks = [
  { title: 'menu_cookie', path: '/cookies-and-privacy' },
  { title: 'P.I. 11939980964', path: '' },
  { title: 'REA MI-2631865', path: '' },
]

const Footer = ({ globalData }) => {
  const { t } = useTranslation()

  const address = globalData.address.split(', ')
  const addressPart1 = address.shift()
  const addressPart2 = address.join(', ')

  function cleanPhone(phone) {
    return phone.replace(/[\W_]+/g, '')
  }

  return (
    <footer className="bg-tuya-rho text-sm overflow-hidden mt-20 px-16 pt-20 pb-10 md:mt-38 md:px-6.5 lg:px-15 xl:px-24">
      <div className="grid grid-cols-1 gap-y-15 md:grid-cols-12 md:gap-x-2.5 md:auto-rows-max lg:grid-cols-4 lg:gap-x-10 xl:gap-x-16">
        <div className="flex flex-col md:col-start-3 md:col-span-3 lg:col-auto">
          <BlockMenu name={t('footer_locations')} items={navLocations} />
        </div>
        <div className="flex flex-col md:col-start-8 md:col-span-4 lg:col-auto">
          <BlockMenu name={t('footer_place')} items={navPlace} />
        </div>
        <div className="flex flex-col md:col-start-3 md:col-span-3 lg:col-auto">
          {<BlockMenu name={t('footer_links')} items={navLinks} />}
        </div>
        <div className="flex flex-col md:col-start-8 md:col-span-4 lg:col-auto">
          <h6 className="text-tuya-alpha tracking-widest mb-4 uppercase">
            <Trans>menu_contact</Trans>
          </h6>
          <ul className="leading-8 text-tuya-chi">
            <li>
              <a href={`tel:+${cleanPhone(globalData.phone)}`}>{globalData.phone}</a>
            </li>
            <li>{globalData.email}</li>
            <li>{addressPart1}</li>
            <li>{addressPart2}</li>
          </ul>
          <div className="flex flex-row mt-3">
            <a href={globalData.facebookLink}>
              <FacebookIcon className="h-9 mr-6.5 text-tuya-chi" />
            </a>
            <a href={globalData.instagramLink}>
              <InstagramIcon className="h-9 mr-6.5 text-tuya-chi" />
            </a>
          </div>
        </div>
      </div>
      <div className="mt-10 md:mt-38">
        <div className="hidden flex-row justify-between items-center md:flex">
          <Pattern />
          <Link to="/">
            <Logo />
          </Link>
          <Pattern />
        </div>
        <p className="text-tuya-omega text-xs leading-4.5 opacity-60 md:text-center md:mt-15">
          © {new Date().getFullYear()} <Trans>footer_copy</Trans>
        </p>
      </div>
    </footer>
  )
}

// Footer.defaultProps = {
//   color: '',
//   name: '',
//   items: [],
//   globalData: {
//     address: null,
//     email: null,
//     facebookLink: null,
//     instagramLink: null,
//     phone: null,
//     pinterestLink: null,
//     locale: null,
//     linkedinLink: null,
//   },
// }
Footer.propTypes = {
  globalData: PropTypes.shape({
    address: PropTypes.string,
    email: PropTypes.string,
    facebookLink: PropTypes.string,
    instagramLink: PropTypes.string,
    phone: PropTypes.string,
    pinterestLink: PropTypes.string,
    locale: PropTypes.string,
    linkedinLink: PropTypes.string,
  }),
}

export default Footer
